// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051406/js/" + chunkId + "." + {"44":"8d370846","225":"625afb07","481":"96f25b5f","486":"ff873c35","770":"efea5dc3"}[chunkId] + ".0.13991022256765184.chunk.js";
};